module.exports = __webpack_public_path__ + "static/media/mark.bf97fea5.png";